<template>
    <v-card class="pa-3">
        <v-card-title>
            Nuevo Paciente
        </v-card-title>
        <v-row class="ma-0">
            <v-col cols="6" class="pb-0">
                <v-text-field label="Nombre" v-model="user.name" outlined></v-text-field>
                <v-text-field label="Email" v-model="user.email" outlined></v-text-field>
                <v-text-field label="Dirección" v-model="user.address" outlined></v-text-field>
                <v-text-field label="Teléfono" v-model="user.phone" outlined></v-text-field>
            </v-col>
            <v-col cols="6" class="pb-0">
                <v-select label="Genero" v-model="user.gender" outlined :items="genders"></v-select>
                <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                    <template v-slot:activator="{ on }">
                        <v-text-field :rules="[v => !!v || 'Campo requerido']" outlined clearable required v-model="user.birthdate" label="Cumpleaños" prepend-inner-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker color="primary" v-model="user.birthdate" @input="datePicker = false"></v-date-picker>
                </v-menu>
                <v-select label="Plan" :items="plans" item-text="name" item-value="id" v-model="user.training_plan_id" outlined></v-select>
                <v-text-field label="Estatura" v-model="user.height" outlined suffix="cms"></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
                <v-autocomplete v-model="user.physical_activity_index" label="Indice de actividad física" :items="indices" outlined item-text="title" item-value="value">
                    <template v-slot:item="data">
                        <template>
                            <v-list-item-content>
                                <v-list-item-title>{{data.item.title}}</v-list-item-title>
                                <v-list-item-subtitle>{{data.item.subtitle}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </template>
                </v-autocomplete>
                <v-textarea v-model="user.note" label="Notas" outlined></v-textarea>
            </v-col>
        </v-row>
        <v-card-actions>
            <v-spacer/>
            <v-btn rounded class="elevation-0 ml-2 px-4" color="grey" @click="close()" style="color:white!important;">Cancelar</v-btn>
            <v-btn rounded class="elevation-0 ml-2 px-4" color="black" @click="save()" :disabled="valid" :loading="gris" style="color:white!important;">Guardar</v-btn>
        </v-card-actions>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>

<script>
import axios from "axios"
export default {
    data: () => ({
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        gris:false,
        datePicker:false,
        genders:['Masculino', 'Femenino'],
        show1: false,
        user:{
            name:'',
            email:'',
            password:'',
            address:'',
            phone:'',
            gender:'',
            birthdate:'',
            training_plan_id:'',
            trainer_id:'',
            physical_activity_index:''
        },
    }),
    computed:{
        indices(){
            return [
                {subtitle: "Nada o poco ejercicio, trabajo de escritorio ", title:"Sedentario", value: "1.200"},
                {subtitle: "Ejercicio Ligero 1 a 3 días/semana", title:"Algo Activo", value: "1.375"},
                {subtitle: "Ejercicio Moderado 3 a 5 días/semana", title:"Activo", value: "1.550"},
                {subtitle: "Ejercicio Fuerte 6 a 7 días/semana", title:"Muy Activo", value: "1.725"},
                {subtitle: "Ejercicio fuerte mas trabajo físico, o Entrenamiento 2 veces diarias", title:"Extra Activo", value: "1.900"}
            ]
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user;
            }
        },
        valid(){
            if(
                (this.user.name!=''&&this.user.name!=undefined&&this.user.name!=null)&&
                (this.user.email!=''&&this.user.email!=undefined&&this.user.email!=null)
            ){
                return false
            }else{
                return true
            }
        },
        plans(){
            return this.currentUser.name != 'Armando Vignau' ? this.$store.state.plan.plans.filter(p=>p.name.includes(this.currentUser.name)) : this.$store.state.plan.plans
        }
    },
    methods:{
        close(){
            this.gris = false
            this.user = {
                name:'',
                email:'',
                password:'',
                address:'',
                phone:'',
                gender:'',
                birthdate:'',
                training_plan_id:'',
                trainer_id:''
            }
            this.$nextTick(() => {
                this.$emit("closeCreateDialog", false);
            })
        },
        save(){
            this.user.trainer_id = this.currentUser.id
            this.gris = true
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users",Object.assign(this.user)).then(response=>{
                this.close()
            }).catch(error=>{
                this.gris = false
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
            })
        }
    }
}
</script>

<style>

</style>